<!-- Background overlay for overlay mode -->
<div class="sidebar-overlay" *ngIf="isOpen && mode === 'overlay'" (click)="close()"></div>

<!-- Sidebar container (should always exist but use CSS for visibility) -->
<div 
  class="sidebar-container" 
  [ngClass]="{ 'sidebar-overlay-mode': mode === 'overlay', 'sidebar-push-mode': mode === 'push' }"
  [@sidebarAnimation]="sidebarState"
  [style.visibility]="isOpen || isAnimating ? 'visible' : 'hidden'"
  [style.pointer-events]="isOpen || isAnimating ? 'auto' : 'none'"
>
  <div class="sidebar-header">
	<button *ngIf="mode === 'overlay'" class="button-close" (click)="close()">
		<mat-icon style="vertical-align:middle;">close</mat-icon>
	</button>
    <h2>{{ title }}</h2>
  </div>

  <!-- Container for dynamically injected component -->
  <div #sidebarContent></div>
</div>